import CONFIG from '../config/config';
import getLanguage from '../helpers/language';
import getCurrentTimeStamp from '../helpers/time';

const loadMessages = async (publicKey: string, conversationId: string) => {
  if (!conversationId) return [];
  if (!publicKey) return [];

  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Ocp-Apim-Subscription-Key', publicKey);

  const requestOptions = {
    method: 'GET',
    headers: headers
  };

  const response = await fetch(CONFIG.domain_url + 'message/get_conversation_messages/' + conversationId, requestOptions);
  const data = await response.json();
  return data.messages;
};

const getConversationStarted = (appId: string | undefined) => {
  if (!appId) return;
  if (!window.sessionStorage) return;

  return window.sessionStorage.getItem(`DCInnovationChatBotConversationStarted_${appId}`);
};

const storeConversationStarted = (appId: string | undefined) => {
  if (!appId) return;
  if (!window.sessionStorage) return;
  if (getConversationStarted(appId)) return;

  window.sessionStorage.setItem(`DCInnovationChatBotConversationStarted_${appId}`, 'true');
};

const getCachedConversation = (appId: string) => {
  if (!appId) return null;

  const cache = window.sessionStorage && window.sessionStorage.getItem(`dcinnovationChatBotConversation_${appId}`);

  return cache ? cache : null;
};

const resetCachedConversation = (appId: string) => {
  if (!appId) return;

  if (window.sessionStorage) {
    window.sessionStorage.removeItem(`dcinnovationChatBotConversation_${appId}`);
  }
};

const getConversationId = async (publicKey: string, appId: string) => {
  if (!publicKey) return null;
  if (!appId) return null;

  const cachedData = getCachedConversation(appId);
  const cachedDataJSON = cachedData ? JSON.parse(cachedData) : {};
  if (cachedData) return cachedDataJSON.id;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Ocp-Apim-Subscription-Key', publicKey);

  const conversationRequestOptions: RequestInit = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      client_id: appId,
      language: getLanguage()
    })
  };

  type Data = {
    id: string;
  }

  try {
    const response = await fetch(CONFIG.domain_url + 'conversation/create_conversation', conversationRequestOptions);
    const data: Data = await response.json();
    if (window.sessionStorage) {
      window.sessionStorage.setItem(`dcinnovationChatBotConversation_${appId}`, JSON.stringify({ id: data.id, timestamp: getCurrentTimeStamp() }));
    }
    return data.id;
  } catch {
    return null;
  }
};

export { loadMessages, getConversationId, storeConversationStarted, getConversationStarted, resetCachedConversation };